import { render, staticRenderFns } from "./UtilityDetailComponent.vue?vue&type=template&id=017d6780&scoped=true&"
import script from "./UtilityDetailComponent.vue?vue&type=script&lang=js&"
export * from "./UtilityDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017d6780",
  null
  
)

export default component.exports